var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "category-filter" }, [
    _c(
      "form",
      {
        ref: "form",
        staticClass: "category-filter--form",
        attrs: { action: _vm.formUrl, method: _vm.formMethod }
      },
      [
        _c("form-field-select", {
          attrs: {
            id: "category",
            items: _vm.categories,
            placeholder: _vm.placeholder,
            facets: ["base", "select"],
            value: _vm.selectedCategory
          },
          on: { change: _vm.onChange }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09a2bbfa", { render: render, staticRenderFns: staticRenderFns })
  }
}